<template>
	<f7-page name="ccm-study-plan-month" class="page-bg-render">
		<f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
				학습 플래너 
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

		<div class="plan-calendar plan-calendar-inline">
			<div class="plan-toolbar">
				<div class="plan-toolbar-inner">
					<div class="plan-left" v-on:click="prevMonth();">◀</div>
					<div class="plan-center" v-on:click="currentMonth();">{{year}}년 {{month}}월</div>
					<div class="plan-right" v-on:click="nextMonth();">▶</div>

					<div class="plan-week" v-on:click="studyPlanWeekPage();">
						주간학습
					</div>
				</div>
			</div>

			<div class="plan-calendar-months">
				<div class="plan-calendar-month">
					<div class="plan-calendar-row plan-calendar-title">
						<div class="plan-calendar-week  day-sun">일</div>					
						<div class="plan-calendar-week">월</div>
						<div class="plan-calendar-week">화</div>
						<div class="plan-calendar-week">수</div>
						<div class="plan-calendar-week">목</div>
						<div class="plan-calendar-week">금</div>
						<div class="plan-calendar-week day-sat">토</div>
					</div>	

					<!-- 데이타 시작 --->
					<template v-for="(item, i) in dateList">
						<div class="plan-calendar-row" :key="'ii' + i">
							
							<template v-for="(subItem, j) in item.days">								
								<div class="plan-calendar-day" :key="'jj' + j">
									<div class="plan-calendar-day-content">
										<div v-bind:class="subItem.dateStyle">
											 {{getDay(subItem.date)}} 
										</div>								
									</div>
									<div class="plan-calendar-data-content">
										<template v-for="(dbItem, a) in subItem.tiemsNoArray">
											<div :key="'aa'+a" class="plan-calendar-data" v-on:click="studyPlanDaypage(dbItem)">
												{{dbItem.TIMES_NO}}
											</div>
										</template>
									</div>								
								
								</div>
							</template>							  

						</div>	
					</template>
				</div>
			
			</div>
	 	</div>

	</f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
	data() {
		return {
			plannerKey : 0,
			groupKey : 0,
			weekNo : 0,
			gradeId : "",
			semesterId : "",
			reviseId : "",
			year: moment().year(),
			month: moment().month()+1,
			dateList: []					
		}
	},
	mounted() {
		const _this  = this;

		_this.plannerKey = _this.$f7route.context.plannerKey;
		_this.groupKey = _this.$f7route.context.groupKey;
		_this.weekNo = _this.$f7route.context.weekNo;
		_this.gradeId = _this.$f7route.context.gradeId;
		_this.semesterId = _this.$f7route.context.semesterId;
		_this.reviseId = _this.$f7route.context.reviseId;

		_this.loadStudyPlanMonth();   
		$(document).on('page:reinit', '.page[data-name="ccm-study-plan-month"]', _this.loadStudyPlanMonth);		
	},
	methods: {	
		loadStudyPlanMonth() {
			const _this = this;

			let param = {
				plannerKey : _this.plannerKey,
				groupKey : _this.groupKey,
				year : _this.year,
				month : _this.month
			}
   
			API.ajaxRequest({
				url: API.getStudyPlanMonthUrl(),
				data: param
			}).then(function (data) {
				_this.dateList = data.dateList;
				_this.checkupDateList();
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
			
		},
		getDay(date) {
			const _this = this;
			var theDay = moment(date);
			return theDay.date();
		},
		checkupDateList() {
			const _this = this;
			var weeks = [];
			var firstDateOfMonth = moment([_this.year, _this.month - 1, 1]);
			var firstDataWeekNo = firstDateOfMonth.day();
			var startDate = moment(firstDateOfMonth);
			if (firstDataWeekNo > 0) {
				startDate = startDate.add(-firstDataWeekNo, "days");
			}
			
			//var index = 0;
			var currDate = startDate;

			for(var w = 0; w < 6; w++) {
				var week = {
					days: []
				};

				for (var d = 0; d < 7; d++) {
					var month = currDate.month() + 1;
					var currDateStr = currDate.format("YYYY-MM-DD");
					var weekNo = currDate.day();

					var day = {
						dateStyle: "",
						date: currDateStr,
						tiemsNoArray : []
					};

					if (weekNo == 0) {
						day.dateStyle = "plan-calendar-day-num day-sun";
					} else if (weekNo == 6) {
						day.dateStyle = "plan-calendar-day-num day-sat";
					} else {
						day.dateStyle = "plan-calendar-day-num day-nomal";
					}

					if(month != _this.month) {
						day.dateStyle += "plan-calendar-day-num disabled";
					}
					
					for(var i = 0; i < _this.dateList.length; i++) {
						var dbItem = _this.dateList[i];

						if(dbItem.STUDY_DATE == currDateStr ) {

							day.tiemsNoArray.push(dbItem);						

						}
					}
	
					week.days.push(day);
					currDate = currDate.add(1,"days");

				}

				weeks.push(week);
			}

			_this.dateList = weeks;
		},
		prevMonth() {
			const _this = this;

			var year = _this.year;
			var month = _this.month;

			if(month > 1) {
				month--;
			} else {
				year--;
				month = 12;
			}

			_this.year = year;
			_this.month = month;

			_this.loadStudyPlanMonth();

		},
		nextMonth() {
			const _this = this;

			var year = _this.year;
			var month = _this.month;

			if(month < 12) {
					month++;
			} else {
				year++;
				month = 1;
			}

			_this.year = year;
			_this.month = month;
			
			_this.loadStudyPlanMonth();

		},
		currentMonth() {
			const _this = this;
			
			_this.year = moment().year();
			_this.month = moment().month()+1;

			_this.loadStudyPlanMonth();
		},
		studyPlanDaypage(item) {
			const _this = this;
			var url = PAGES.MENU_CCM_STUDY_PLAN_DAY;

			var param = {
				plannerKey : _this.plannerKey,				
				timesNo : item.TIMES_NO,
				groupKey : _this.groupKey,
				gradeId : _this.gradeId,
				reviseId : _this.reviseId,
				semesterId : _this.semesterId	  			
			};
			PAGES.goPage(url, param);
		},
		studyPlanWeekPage() {
			const _this = this;
			var url = PAGES.MENU_CCM_STUDY_PLAN_WEEK;

			var param = {
				plannerKey : _this.plannerKey,
				weekNo : _this.weekNo,
				groupKey : _this.groupKey,
				gradeId : _this.gradeId,
				reviseId : _this.reviseId,
				semesterId : _this.semesterId
			}
			
			PAGES.goPage(url,param);
		},
	}
}
</script>